var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('item-field',{attrs:{"fields":_vm.itemObject.itemSchema.field}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }